import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface LocalidadesZonaModalData {
  titulo: string;
  localidades: Array<{ nombre: string; provincia: string }>;
}

@Component({
  selector: 'app-localidades-zona-modal',
  templateUrl: './localidades-zona-modal.component.html',
})
export class LocalidadesZonaModalComponent {
  titulo = '';
  localidades: Array<{ nombre: string; provincia: string }> = [];

  constructor(
    public dialogRef: MatDialogRef<LocalidadesZonaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LocalidadesZonaModalData,
  ) {
    this.titulo = data && data.titulo ? data.titulo : 'Localidades';
    this.localidades = (data && data.localidades) || [];
  }

  cerrar() {
    this.dialogRef.close();
  }
}
